module.exports = __webpack_public_path__ + "img/img01.39aef2a4.png";